export const homeRoute = "/"
export const profileRoute = "/profiel"
export const logoutRoute = "/logout"
export const voteRoute = "/stem"
